<template>
  <el-dialog
    :title="isMyownOrgSys ? '編輯單位白名單' : '設定分享單位'"
    fullscreen
    @close="handleDlgClose"
    :visible.sync="innerVisible"
  >
    <div class="container" v-loading="isLoading">
      <div class="row justify-content-between">
        <div class="px-2">
          <el-form
            ref="queryForm"
            :model="queryForm"
            label-width="100px"
            :inline="true"
            @keyup.enter.native="handleQueryClick(queryForm)"  @submit.native.prevent
          >
            <el-form-item label="關鍵字">
              <el-input
                v-model="queryForm.qstr"
                placeholder="帳號、名稱"
              ></el-input>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="handleQueryClick(queryForm)"
                >查詢</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <div>
          <el-button
            type="primary"
            @click="handleBatchJoin"
            size="small"
            :disabled="selectedRow.length === 0"
          >
            {{ isMyownOrgSys ? "批次加入" : "批次分享" }}
          </el-button>

          <el-button
            type="danger"
            @click="handleBatchQuit"
            size="small"
            :disabled="selectedRow.length === 0"
            >批次移除</el-button
          >
        </div>
      </div>
    </div>

    <CCard>
      <CCardHeader>
        <CIcon name="cib-apple-podcasts" /> 頻道：{{ channelName }}
      </CCardHeader>
      <CCardBody>
        <CRow>
          <el-table
          :border="true"
            v-loading="isLoading"
            ref="dataTable"
            @selection-change="handleSelectionChange"
            :data="organizations"
            @sort-change="sortChange"
            :default-sort="{ prop: defaultSortCol, order: defaultOrder }"
            stripe
            style="width: 100%"
          >
            <el-table-column type="selection" width="45"> </el-table-column>

            <el-table-column
              :prop="defaultSortCol"
              type="index"
              :index="indexFormatter"
              fixed
            >
            </el-table-column>

            <el-table-column label="單位名稱" width="220">
              <template #default="scope">
                <el-tag :style="getTagStyle(scope.row.color)">{{ scope.row.name }}</el-tag>
              </template>
            </el-table-column>

            <el-table-column :label="isMyownOrgSys ? '加入白名單' : '分享頻道'">
              <template #default="scope">
                <el-switch
                  :value="isSubscribed(scope.row)"
                  active-text="是"
                  inactive-text="否"
                  :disabled="isSwitchDisabled(scope.$index)"
                  v-loading="isSwitchDisabled(scope.$index)"
                  @change="
                    isInList =>
                      changeWhiteStatus(isInList, scope.row, scope.$index)
                  "
                >
                </el-switch>
              </template>
            </el-table-column>
          </el-table>
        </CRow>

        <CRow>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-sizes="[50, 100, 200]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </CRow>
      </CCardBody>
    </CCard>

    <template #footer class="dialog-footer">
      <el-button @click="innerVisible = false">關閉</el-button>
    </template>
  </el-dialog>
</template>

<script>
import API from "@/api/";
import appConfig from "../../appConfig";
import { mapGetters } from "vuex";
import tagColorsMixin from "@/components/mixin/tagColors.js";
export default {
  mixins: [tagColorsMixin],
  model: {
    prop: "visible",
    event: "toggleVisible",
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    channelId: {
      type: Number,
      default: null,
    },
    channelName: {
      type: String,
      default: null,
    },
  },
  computed: {
    isMyownOrgSys() {
      return this.myownOrg === appConfig.SYS_ORG_NAME;
    },
    ...mapGetters({
      myownOrg: "auth/orgName",
      organizations: "organization/organizations",
      total: "organization/total",
      offset: "organization/offset",
      sort: "organization/sort",
      order: "organization/order",
    }),
    innerVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("toggleVisible", val);
      },
    },
  },
  data() {
    return {
      defaultSortCol: "organization.id",
      defaultOrder: "ascending",
      formLabelWidth: "100px",
      isLoading: false,
      disabledSwitchIdx: [],
      selectedRow: [],
      pageSize: 50,
      currentPage: 1,
      queryForm: {
        qstr: "",
      },
      activeQueryForm: {
        qstr: "",
      },
    };
  },
  created() {
    this.$store.commit("organization/CLEAR");
    this.$store.commit("organization/SET_SORT", this.defaultSortCol);
    this.$store.commit("organization/SET_ORDER", this.defaultOrder);
    if (this.innerVisible) {
      //NOTE: always start from the first page
      this.query(this.pageSize, 0, this.sort, this.order);
    }
  },
  methods: {
    isSwitchDisabled(idx) {
      return this.disabledSwitchIdx.includes(idx);
    },

    batchHandler(isSkipped, actionFunc, successMsg) {
      let promises = [];
      this.isLoading = true;
      let runningItem = [];
      let failedItem = [];
      this.selectedRow.forEach(row => {
        if (!isSkipped(row)) {
          runningItem.push(row);
          promises.push(actionFunc(row, null, false, false));
        }
      });

      Promise.allSettled(promises)
        .then(results => {
          results.forEach((res, idx) => {
            //if (res.status === "fulfilled") {
            //this.$refs.dataTable.toggleRowSelection(this.members[selectedIdx[idx]], false);
            //}
            if (res.status === "rejected") {
              //console.log(`rejected: pushed name = ${runningItem[idx].name}`);
              failedItem.push(runningItem[idx].name);
              //this.$refs.dataTable.toggleRowSelection(this.members[selectedIdx[idx]], true);
            }
          });

          //console.log(`failedItem = ${JSON.stringify(failedItem)}`);
          if (!failedItem.length) {
            this.$message.success(successMsg);
          } else {
            this.$message.error("部分項目發生錯誤!");
          }
        })
        .finally(() => {
          this.query(
            this.pageSize,
            this.offset,
            this.sort,
            this.order,
            this.activeQueryForm
          ).then(() => {
            failedItem.forEach(failedName => {
              const failedOne = this.organizations.find(
                item => item.name === failedName
              );
              failedOne &&
                this.$refs.dataTable.toggleRowSelection(failedOne, true);
            });
            //NOTE: we intentionally set loading to false ONLY when query succeeds
            this.isLoading = false;
          });
        });
    },

    handleBatchJoin() {
      const isSkipped = row => (this.isSubscribed(row) ? true : false);
      this.batchHandler(isSkipped, this.addToList.bind(this), "批次加入成功");
    },
    handleBatchQuit() {
      const isSkipped = row => (!this.isSubscribed(row) ? true : false);
      this.batchHandler(
        isSkipped,
        this.removeFromList.bind(this),
        "批次移除成功"
      );
    },

    handleSelectionChange(rows) {
      //console.log(`handleSelectionChange: val = ${JSON.stringify(rows)}`);
      this.selectedRow = rows;
    },

    //getAdminNames(admins) {
    //return admins.reduce((acc, cur) => {
    //return `${acc}${cur.name}; `;
    //}, "")
    //},
    changeWhiteStatus(isSubscr, org, index) {
      const isChecked = this.selectedRow.find(row => row.name === org.name);
      this.disabledSwitchIdx.push(index);
      let p;
      if (isSubscr) {
        p = this.addToList(org, index);
      } else {
        p = this.removeFromList(org, index);
      }
      p.finally(() => {
        isChecked &&
          this.$refs.dataTable.toggleRowSelection(
            this.organizations[index],
            true
          );

        const found = this.disabledSwitchIdx.indexOf(index);
        found !== -1 && this.disabledSwitchIdx.splice(found, 1);
      });
    },

    addToList(org, index, updateStore = true, showMsg = true) {
      const params = {};
      params.channelId = this.channelId;
      params.organizationId = org.id;
      return API.chnlOrgWhitelist.addWhiteOrg(params).then(res => {
        if (updateStore) {
          const newOrg = { ...org };
          const whiteList = [{}];
          whiteList[0].id = res.data.id;
          newOrg.channelOrganizationWhitelist = whiteList;

          const payload = {};
          payload.newElem = newOrg;
          payload.index = index;
          this.$store.commit("organization/CHANGE_ELEMENT", payload);
        }

        showMsg &&
          this.$message({
            type: "success",
            message: "加入成功!",
          });
      });
    },

    removeFromList(org, index, updateStore = true, showMsg = true) {
      return API.chnlOrgWhitelist
        .removeWhiteOrg(org.channelOrganizationWhitelist[0].id)
        .then(() => {
          if (updateStore) {
            const newOrg = { ...org };
            newOrg.channelOrganizationWhitelist = [];

            const payload = {};
            payload.newElem = newOrg;
            payload.index = index;
            this.$store.commit("organization/CHANGE_ELEMENT", payload);
          }

          showMsg &&
            this.$message({
              type: "success",
              message: "移除成功!",
            });
        });
    },

    isSubscribed(org) {
      return org.channelOrganizationWhitelist.length > 0 ? true : false;
    },
    handleQueryClick(queryForm) {
      this.currentPage = 1; //reset pagination to the first page
      this.activeQueryForm = { ...queryForm };
      this.query(this.pageSize, 0, this.sort, this.order, this.activeQueryForm);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.query(val, this.offset, this.sort, this.order, this.activeQueryForm);
    },
    handleCurrentChange(page) {
      this.query(
        this.pageSize,
        this.pageSize * (page - 1),
        this.sort,
        this.order,
        this.activeQueryForm
      );
    },
    query(max, offset, sort, order, params = {}) {
      return this.$store
        .dispatch("organization/list", {
          channel: this.channelId,
          max: max,
          offset: offset,
          sort,
          order,
          ...params,
        })
        .finally(() => {
          this.disabledSwitchIdx = [];
        });
    },
    indexFormatter(index) {
      return `#${parseInt(this.offset) + index + 1}`;
    },
    sortChange(args) {
      if (args.order === null) {
        this.$store.commit("organization/SET_SORT", this.defaultSortCol);
        this.$store.commit("organization/SET_ORDER", this.defaultOrder);
      } else {
        this.$store.commit("organization/SET_SORT", args.prop);
        this.$store.commit("organization/SET_ORDER", args.order);
      }
      this.query(
        this.pageSize,
        this.offset,
        this.sort,
        this.order,
        this.activeQueryForm
      );
    },
    handleDlgClose() {
      this.$store.dispatch("chnlOrgWhitelist/list", null);
    },
  },
};
</script>

<style></style>
